/**
 * Metadatos de cabecera PDF parcial Plastyverg (código ID-N → versión / fecha).
 * Consultado por tareaParcialPdf y tareaParcialBlankPdf.
 */

export type PlastyvergPdfHeaderCodeMeta = {
  codigo: string;
  version: string;
  fechaVersion: string;
};

/** Catálogo inicial; ampliar según nuevos códigos de modeloTarea. */
export const PLASTYVERG_PDF_HEADER_CODE_META: Record<string, Omit<PlastyvergPdfHeaderCodeMeta, 'codigo'>> = {
  'ID-23': {version: '12', fechaVersion: '26-10-2026'},
  'ID-24': {version: '08', fechaVersion: '26-10-2026'},
  'ID-25': {version: '09', fechaVersion: '26-10-2026'},
  'ID-26': {version: '09', fechaVersion: '26-10-2026'},
};

/** Captura "ID-23 " (código + espacio) en el título del modelo. */
const ID_CODE_IN_TITLE_RE = /\b(ID-\d+)\s+/i;

export function extractPlastyvergPdfHeaderCodigo(titulo?: string | null): string | null {
  const match = String(titulo || '').match(ID_CODE_IN_TITLE_RE);
  if (!match?.[1]) return null;
  return match[1].toUpperCase();
}

/** Quita el prefijo "ID-N " del título visible en el PDF. */
export function stripPlastyvergPdfHeaderCodigoFromTitle(titulo?: string | null): string {
  return String(titulo || '')
    .replace(ID_CODE_IN_TITLE_RE, '')
    .replace(/^[\s\-–—:|]+/, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

export function getPlastyvergPdfHeaderCodeMeta(codigo?: string | null): PlastyvergPdfHeaderCodeMeta | null {
  if (!codigo) return null;
  const key = String(codigo).toUpperCase();
  const entry = PLASTYVERG_PDF_HEADER_CODE_META[key];
  if (!entry) return null;
  return {codigo: key, version: entry.version, fechaVersion: entry.fechaVersion};
}

export type ResolvedPlastyvergPdfHeader = {
  displayTitle: string;
  codeMeta: PlastyvergPdfHeaderCodeMeta | null;
};

/**
 * Para Plastyverg: extrae ID del título, lo oculta en displayTitle y resuelve versión/fecha.
 * Si no es Plastyverg o no hay ID, deja el título intacto y codeMeta null.
 */
export function resolvePlastyvergPdfHeaderTitle(
  titulo: string | null | undefined,
  isPlastyverg: boolean,
): ResolvedPlastyvergPdfHeader {
  const original = String(titulo || '');
  if (!isPlastyverg) {
    return {displayTitle: original, codeMeta: null};
  }
  const codigo = extractPlastyvergPdfHeaderCodigo(original);
  if (!codigo) {
    return {displayTitle: original, codeMeta: null};
  }
  return {
    displayTitle: stripPlastyvergPdfHeaderCodigoFromTitle(original),
    codeMeta: getPlastyvergPdfHeaderCodeMeta(codigo),
  };
}
